export const debugQueryKeys = {
  all: ['debug'] as const,
  jobSourcing: (jobId: string) =>
    [...debugQueryKeys.all, 'job-sourcing', jobId] as const,
};
